// src/core/hooks/use-header-scroll-direction.ts
"use client"

import { useEffect, useRef, useState } from "react"

// زیر این مقدار یعنی هنوز بالای صفحه‌ایم؛ نه حالت مخفی معنی داره نه شناور
const TOP_THRESHOLD = 80
// حداقل جابه‌جایی اسکرول برای اینکه جهت حرکت رو معتبر بدونیم (نویز رو فیلتر می‌کنه)
const MIN_DELTA = 6

export type HeaderScrollDirection = {
  // داره اسکرول پایین می‌ره و از بالای صفحه فاصله گرفته -> هدر باید بره بیرون از دید
  hidden: boolean
  // داره اسکرول بالا می‌ره ولی هنوز به تاپ صفحه نرسیده -> حالت شناورِ نیمه‌شفاف با فاصله از کناره‌ها
  floating: boolean
}

export function useHeaderScrollDirection(): HeaderScrollDirection {
  const [state, setState] = useState<HeaderScrollDirection>({
    hidden: false,
    floating: false,
  })

  const lastY = useRef(0)
  const ticking = useRef(false)

  useEffect(() => {
    lastY.current = window.scrollY

    const onScroll = () => {
      if (ticking.current) return
      ticking.current = true

      requestAnimationFrame(() => {
        const y = window.scrollY
        const diff = y - lastY.current

        if (y < TOP_THRESHOLD) {
          lastY.current = y
          setState(prev =>
            prev.hidden || prev.floating ? { hidden: false, floating: false } : prev
          )
          ticking.current = false
          return
        }

        if (Math.abs(diff) >= MIN_DELTA) {
          const goingDown = diff > 0
          lastY.current = y
          setState(prev => {
            const next = { hidden: goingDown, floating: !goingDown }
            return prev.hidden === next.hidden && prev.floating === next.floating ? prev : next
          })
        }

        ticking.current = false
      })
    }

    window.addEventListener("scroll", onScroll, { passive: true })
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  return state
}